import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';
import { DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import Dropdown from 'Components/Utility/Dropdown';
import DropdownMenu from 'Components/Utility/DropdownMenu';
import DropdownToggle from 'Components/Utility/DropdownToggle';
import Drm from 'Components/Utility/Drm';
import 'Features/Product/components/ProductCommerce/DrmSwitcher.scss';

const DrmSwitcher = ({
  drmEditions,
  currentDrm,
}) => {
  const drmLabels = {
    steam: 'Steam',
    uplay: 'Ubisoft Connect',
    epicgames: 'Epic Games',
    gog: 'GOG.com',
    xbox: 'Xbox',
  };

  const excludes = [
    'steam',
    'bethesda',
    'playstation',
    'xbox',
    'microsoft',
  ];

  let showLabel = true;
  if (includes(excludes, currentDrm)) {
    showLabel = false;
  }

  const [isOpen, setIsOpen] = useState(false);

  if (!currentDrm) return false;
  if (isEmpty(drmEditions)) return false;

  return (
    <div id="drm-switcher" className="DrmSwitcher">
      <Dropdown
        isOpen={isOpen}
        toggle={() => setIsOpen(!isOpen)}
        id="drm-switcher-dropdown"
        className="DrmSwitcher__dropdown"
      >
        <DropdownToggle
          className="DrmSwitcher__drmToggle btn-reset-style"
        >
          <div className="DrmSwitcher__currentDrm">
            <div className="DrmSwitcher__currentDrmIcon">
              <Drm drmType={currentDrm} />
              {showLabel &&
                <div className="DrmSwitcher__currentDrmName">
                  {drmLabels[currentDrm] ?
                    drmLabels[currentDrm]
                    :
                    currentDrm
                  }
                </div>
              }
            </div>
            <div className="DrmSwitcher__currentDrmChevron">
              <FontAwesomeIcon icon={faChevronDown} />
            </div>
          </div>

        </DropdownToggle>
        <DropdownMenu>
          {drmEditions.map(drmEdition =>
            <DropdownItem
              key={Math.random()}
              tag={Link}
              to={`/${drmEdition.type}/${drmEdition.slug}`}
              className={classNames('DrmSwitcher__dropdownItemContainer', { 'DrmSwitcher__dropdownItemContainer--active': currentDrm === drmEdition.drm_string })}
            >
              <div className="DrmSwitcher__dropdownItem">
                <div className="DrmSwitcher__dropdownItem__radioButtondDrmNameContainer">
                  <div className="DrmSwitcher__dropdownItem__radioButtonContainer">
                    <input
                      checked={currentDrm === drmEdition.drm_string}
                      type="radio"
                      value="public"
                      name={drmEdition.drm_string}
                      aria-label={drmEdition.drm_string}
                      onChange={() => { }}
                    />
                  </div>
                  <div className="DrmSwitcher__dropdownItem__drmName mr-6">
                    {drmLabels[drmEdition.drm_string] ?
                      drmLabels[drmEdition.drm_string]
                      :
                      drmEdition.drm_string
                    }
                  </div>
                </div>
                <div className="DrmSwitcher__dropdownItem__drmLogoContainer">
                  <Drm drmType={drmEdition.drm_string} iconSize="small" />
                </div>
              </div>
            </DropdownItem>,
          )}

        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

DrmSwitcher.propTypes = {
  drmEditions: PropTypes.arrayOf(PropTypes.shape({})),
  currentDrm: PropTypes.string,
};

DrmSwitcher.defaultProps = {
  drmEditions: [],
  currentDrm: '',
};


export default DrmSwitcher;
